import { css } from '@emotion/core';
import theme from '../../themes/default';

const paper = css`
  position: absolute;
  overflow-y: auto;
  overflow-x: hidden;
  // So we see the popover when it's empty.
  // It's most likely on issue on userland.
  min-width: 16px;
  min-height: 16px;
  max-width: calc(100% - 32px);
  max-height: calc(100% - 32px);
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: none;
  border-radius: ${theme.borderRadius.medium};
`;

const unelevated = css`
  box-shadow: ${theme.shadow.low};
`;

const elevated = css`
  box-shadow: ${theme.shadow.xHigh};
`;

const above = ({ spacing }) => css`
  margin-top: -${spacing || theme.spacing.xSmall};
`;

const under = ({ spacing }) => css`
  margin-top: ${spacing || theme.spacing.xSmall};
`;

const blockDisplay = css`
  display: inline-block;
  width: 100%;
`;

export default {
  paper: {
    base: paper,
    above,
    under,
    elevated,
    unelevated,
  },
  blockDisplay,
};
